module.exports = __webpack_public_path__ + "static/fonts/iconfont.07ce6922.woff";